import { handleAction } from '@mendeley-internal/lib-js-redux-actions';
import { setViewport } from '../actions/viewport';

const initialState = { width: null };
export default handleAction(setViewport, (state, { payload }) => payload, initialState);



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/viewport.js